import {
  GenerateViewEventParams,
  guideContextGenerator,
  viewEventGenerator,
} from './contextGenerators';

export const guideViewEventGenerator = ({
  viewUuid,
  date,
  service,
  title,
  programId,
  entityId,
  viewMode,
}: GenerateViewEventParams) => {
  const event = viewEventGenerator(viewUuid, 'entity', viewMode);
  const context = guideContextGenerator({
    date,
    service,
    label: title,
    programId,
    entityId,
  });

  return { event, context };
};
